module.exports = "<hybse-admin-create-page [actionType]=\"'edit'\">\n\n</hybse-admin-create-page>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/page/update/update-page.component.html
// module id = ../../../../../src/app/components/pages/page/update/update-page.component.html
// module chunks = main